import React from 'react';
import { WeezHeader, Card, Form, Input, Message, Button, Icon, SplitContainer, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { fetcher } from '@weezevent/weezjs-core';
import { useForm } from '../../../../utils/validators';
import { useHistory } from 'react-router-dom';
import { ticketOfficeContext } from '../../../../components/routing/ticketOfficeRouter';
import Style from './operatorCreation.module.css';

export default function OperatorEdit({ organization, ticket_office, operator_id }) {
    const { t } = useTranslation();
    let history = useHistory();
    const syncTicketOffice = React.useContext(ticketOfficeContext);

    const thisOperator = React.useMemo(() => {
        return ticket_office.operators.find(o => Number(o.id) === Number(operator_id));
    }, [ticket_office, operator_id]);

    let [form, updateForm, onChangeFormObject] = useForm({
        name: thisOperator?.name || '',
        email: thisOperator?.email || '',
        password: thisOperator?.password || ''
    });
    const toast = React.useContext(ToastContext);

    const editOperator = React.useCallback(() => {
        fetcher
            .patch(`/ticket/organizations/${organization.id}/ticket_office/${ticket_office.id}/users/${operator_id}`, {
                data: {
                    name: form.name,
                    email: form.email,
                    password: form.password
                }
            })
            .then(() => {
                toast.success(t('ticket.ticket_offices.operator_creation.request.sucess'));
                syncTicketOffice({
                    allow_cache: false,
                    cache: false
                });
                history.push(`/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/users`);
            })
            .catch(err => {
                toast.error(t('ticket.ticket_offices.operator_creation.request.failed'));
            });
    }, [organization, form, ticket_office, operator_id, toast, syncTicketOffice]);

    const resetForm = React.useCallback(() => {
        onChangeFormObject({ ...form, name: '', email: '', password: '' });
    }, [form, onChangeFormObject]);

    const listOperators = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/users`);
    }, [history, organization, ticket_office]);

    return (
        <>
            <div>
                <WeezHeader
                    backLink={{
                        onClick: listOperators
                    }}
                    title={thisOperator?.name}
                    rightComponent={[
                        <Button
                            className={Style['button_cancel']}
                            key={'Reset'}
                            label={
                                <div>
                                    <Icon name="Reset" inverted={true} />
                                    {t('ticket.common.action.reset')}
                                </div>
                            }
                            size={'regular'}
                            onClick={resetForm}
                        />,
                        <Button key={'Save'} primary label={t('ticket.common.action.save')} onClick={editOperator} />
                    ]}
                    bottomComponent={[
                        <Button primary key={'primary'} label={t('ticket.common.action.save')} />,
                        <Button key={'secondary'} label={t('ticket.common.action.cancel')} />
                    ]}
                />
            </div>
            <SplitContainer
                additional={
                    <Message mini title={t('ticket.ticket_offices.operator_creation.message.title')} type="tips">
                        {t('ticket.ticket_offices.operator_creation.message.content')}
                    </Message>
                }
            >
                <div className="add_operator_card">
                    <Card>
                        <Card.Header>
                            <Card.Title title={t('ticket.ticket_offices.operator_creation.card.header.title')} />
                            <Card.SubTitle title={t('ticket.ticket_offices.operator_creation.card.header.subtitle')} />
                        </Card.Header>
                        <Card.Content>
                            <Form.Field>
                                <Form.Label label={t('ticket.ticket_offices.operator_creation.card.form.name')} />
                                <Input value={form.name} onChange={event => updateForm('name', event.target.value)} />
                            </Form.Field>
                            <Form.Field>
                                <Form.Label label={t('ticket.ticket_offices.operator_creation.card.form.email')} />
                                <Input value={form.email} onChange={event => updateForm('email', event.target.value)} />
                            </Form.Field>
                            <Form.Field>
                                <Form.Label label={t('ticket.ticket_offices.operator_creation.card.form.password')} />
                                <Input value={form.password} onChange={event => updateForm('password', event.target.value)} />
                            </Form.Field>
                        </Card.Content>
                    </Card>
                </div>
                <div></div>
            </SplitContainer>
        </>
    );
}
